// extracted by mini-css-extract-plugin
export var logo = "Logo-module--logo--V-yKS";